import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { PopoverComponent } from '../popover.component';

@Injectable({
  providedIn: 'root'
})
export class PopoverService {
  private lastPopover!: PopoverComponent;
  popoversList: Subject<any> = new Subject()
  constructor(private ngZone: NgZone) {
    this.popoversList.subscribe((popover) => {
      this.lastPopover = popover;
    })
  }
  closeLastPopover(event: MouseEvent) {
    this.ngZone.runOutsideAngular(() => { // Running outside Angular's zone
      const target = event.target as HTMLElement;
      if ((target.closest('epmax-master')|| target.closest('epmax-popup')) && !target.closest('epmax-popover')) {
        this.lastPopover?.close()
      }
    });
 

  }
closeLastPopoverManually() {
  this.lastPopover?.close();
}

}
